export default __webpack_public_path__ + "static/media/hospital_black.8411b353.svg";